'use client'

import { PropsWithChildren } from 'react';
import Header from '../Components/Layout/Header';
import { useOrderTypeContext } from '../Contexts/OrderTypeContext';
import FooterStoreCounter from '../Components/Layout/FooterStoreCounter';
import { useStoreContext } from '../Contexts/StoreContext';
import { ImSpinner8 } from 'react-icons/im';
import Footer from '../Components/Layout/Footer';
import { useTranslation } from 'react-i18next';

interface DefaultLayoutProps {
showHeader?: boolean;
showFooter?: boolean;
isInDrawer?: boolean;
className?: string;
}

const DefaultLayout = ({
    children,
    showHeader = true,
    showFooter = true,
    isInDrawer = false,
    className
}: PropsWithChildren<DefaultLayoutProps>) => {

    const { t } = useTranslation();
    const { isStoreCounter } = useOrderTypeContext();
    const { loadingStore } = useStoreContext();

    return (
        <div className={`${className} flex flex-col min-h-dvh absolute w-full items-center`}>

            {/* HEADER */}
            {showHeader && <Header />}

            {/* CONTAINER */}
            <section className={`flex flex-col flex-grow w-full md:container transition-all ${!isInDrawer ? 'pb-6 md:pb-0 mb-14 md:mb-0' : ''}`}>

                {/* CONTENT */}
                <section className={`flex flex-grow transition-width ease-in-out duration-200 ${!isInDrawer ? 'p-3 md:p-6 lg:p-6' : ''}`}>
                    <div className='flex flex-col w-full gap-8 md:gap-12'>
                        {loadingStore
                            ?
                                <div className="flex flex-col gap-1 items-center justify-center text-sm text-gray-500 max-h-full min-h-96">
                                    <div className="flex items-center gap-1"><ImSpinner8 className="animate-spin" /> <span>{t('layout.loading')}</span></div>
                                </div>
                            : children
                    }
                    </div>
                </section>

            </section>

            {/* FOOTER */}
            {showFooter ? (
                isStoreCounter
                    ? <FooterStoreCounter />
                    : <Footer />
            ) : null}
        </div>
    )
}

export default DefaultLayout;